import { ONBOARDING_FAST_INTERVIEW_ENABLED } from '../../../utils/constants';

/**
 * Resolve whether the interview page should use the voice agent (Andrea) or Luci.
 * Onboarding follows REACT_APP_ONBRD_INT_FAST; practice follows localStorage.
 */
export function resolveUseVoiceAgent(isOnboarding: boolean): boolean {
  if (isOnboarding) {
    return ONBOARDING_FAST_INTERVIEW_ENABLED;
  }
  return localStorage.getItem('use_voice_agent') === 'true';
}
